import http from '../http'

const API_URL = 'item-formats'

class ItemFormatsAPI {
  // Lista los formatos descargables (en blanco) de un ítem. Ej: list('1.1.2')
  async list(itemCode) {
    return await http(`${API_URL}/${itemCode}`)
  }

  // Construye la URL pública de descarga a partir de la key relativa del bucket.
  url(bucketKey) {
    return encodeURI(`${process.env.VUE_APP_BUCKET}/${bucketKey}`)
  }
}

export default new ItemFormatsAPI()
